

<template>
  <div class="mock-exam-detail">
    <div class="container mock-exam-detail__inner">
      <button
        type="button"
        class="mock-exam-detail__back"
        aria-label="Back to mock exams"
        @click="goBack"
      >
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="M19 12H5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M11 18l-6-6 6-6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span>Back</span>
      </button>

     <!-- Test Number -->
    <h5 class="text-secondary mb-2">
      {{ level.toUpperCase() }} - Test {{ testId }}
    </h5>

    <!-- Title -->
    <h1 class=" mb-4">IELTS Familiarisation Test</h1>

    <p class="fw-bold border-bottom pb-2">Today</p>

    <!-- Listening Card -->
    <div class="card p-4 mb-4 shadow-sm">
      <h3 class="fw-bold">Listening</h3>
      <p class="status-text fw-bold">Not completed</p>
      <p>Timing: <strong>{{ listeningDuration }} minutes</strong></p>

     <div class="border rounded p-4 mt-3 bg-light">
  <div
    class="d-flex align-items-center justify-content-between"
    @click="showListeningInfo = !showListeningInfo"
    style="cursor: pointer;"
  >
    <div class="d-flex align-items-center">
      <i
        class="bi bi-chevron-down me-2"
        :style="{ transform: showListeningInfo ? 'rotate(180deg)' : 'rotate(0deg)' }" 
      ></i>

      <span class="test-info-text">Test information.</span>
      <span class="status-text ms-2">Not confirmed.</span>
    </div>
  </div>
<transition name="slide">
  <div v-show="showListeningInfo" class="mt-4">
    <video controls class="w-100 rounded">
      <source src="/videos/listening-test.mp4" type="video/mp4" />
    </video>

    <div class="mt-3">
      <h5>Ready?</h5>
      <p>Please confirm that you have understood the instructions above.</p>

      <button
  class="btn  btn-sm confirm-btn d-inline-flex align-items-center justify-content-center"
@click="isConfirmed ? startListening() : isConfirmed = true"
  >
 <i v-if="isConfirmed" class="bi bi-arrow-right ms-2 arrow-icon"></i>
  {{ isConfirmed ? "Start Listening" : "✓ I confirm" }}
  
  
</button>
    </div>
  </div>
  </transition>
</div>
    </div>

    
    <!-- Reading Card -->
<!-- Reading Card -->
<div class="card p-4 shadow-sm">
  <h3 class="fw-bold">Reading</h3>
  <p class="status-text fw-bold">Not completed</p>
  <p>Timing: <strong>{{ readingDuration }} minutes</strong></p>

  <div class="border rounded p-4 mt-3 bg-light">

    <!-- Header (Clickable Row) -->
    <div
      class="d-flex align-items-center justify-content-between"
      @click="showReadingInfo = !showReadingInfo"
      style="cursor: pointer;"
    >
      <div class="d-flex align-items-center">

        <!-- Arrow (same behavior as Listening) -->
        <i
          class="bi bi-chevron-down me-2 arrow-icon"
          :style="{
            transform: showReadingInfo ? 'rotate(180deg)' : 'rotate(0deg)'
          }"
        ></i>

        <span class="test-info-text">Test information.</span>
        <span class="status-text ms-2">Not confirmed.</span>

      </div>
    </div>

    <!-- Expand Section -->
    <transition name="slide">
      <div v-show="showReadingInfo" class="mt-4">

        <!-- Video -->
        <video controls class="w-100 rounded">
          <source src="/videos/reading-test.mp4" type="video/mp4" />
        </video>

        <!-- Confirmation -->
        <div class="mt-3">
          <h5>Ready?</h5>
          <p>Please confirm that you have understood the instructions above.</p>

          <button
            class="btn btn-sm confirm-btn d-inline-flex align-items-center justify-content-center"
            @click="isReadingConfirmed ? startReading() : isReadingConfirmed = true"
          >
            <i
              v-if="isReadingConfirmed"
              class="bi bi-arrow-right ms-2 arrow-icon"
            ></i>

            {{ isReadingConfirmed ? "Start Reading" : "✓ I confirm" }}
          </button>

        </div>

      </div>
    </transition>

  </div>
</div>


<!-- Writing Card -->
<div class="card p-4 shadow-sm mt-4">
  <h3 class="fw-bold">Writing</h3>
  <p class="status-text fw-bold">Not completed</p>
  <p>Timing: <strong>{{ writingDuration }} minutes</strong></p>

  <div class="border rounded p-4 mt-3 bg-light">

    <!-- Header -->
    <div
      class="d-flex align-items-center justify-content-between"
      @click="showWritingInfo = !showWritingInfo"
      style="cursor: pointer;"
    >
      <div class="d-flex align-items-center">

        <!-- Arrow -->
        <i
          class="bi bi-chevron-down me-2 arrow-icon"
          :style="{
            transform: showWritingInfo ? 'rotate(180deg)' : 'rotate(0deg)'
          }"
        ></i>

        <span class="test-info-text">Test information.</span>
        <span class="status-text ms-2">Not confirmed.</span>

      </div>
    </div>

    <!-- Expand Section -->
    <transition name="slide">
      <div v-show="showWritingInfo" class="mt-4">

        <!-- Video -->
        <video controls class="w-100 rounded">
          <source src="/videos/writing-test.mp4" type="video/mp4" />
        </video>

        <!-- Confirmation -->
        <div class="mt-3">
          <h5>Ready?</h5>
          <p>Please confirm that you have understood the instructions above.</p>

          <button
            class="btn btn-sm confirm-btn d-inline-flex align-items-center justify-content-center"
            @click="isWritingConfirmed ? startWriting() : isWritingConfirmed = true"
          >
            <i
              v-if="isWritingConfirmed"
              class="bi bi-arrow-right ms-2 arrow-icon"
            ></i>

            {{ isWritingConfirmed ? "Start Writing" : "✓ I confirm" }}
          </button>

        </div>

      </div>
    </transition>

  </div>
</div>

  </div>
  </div>
</template>


<script setup lang="ts">
import { ref, onMounted } from "vue"
import { useRoute, useRouter } from "vue-router"
import { resolveTest } from "@/api/tests"
import { getListeningExam } from "@/api/listening"
import { getReadingExam } from "@/api/reading"
import { getWritingExam } from "@/api/writing"
import { handleError } from "@/services/errorHandler"


const route = useRoute()
const router = useRouter()
const showReadingInfo = ref(false)
const isReadingConfirmed = ref(false)
const showWritingInfo = ref(false)
const isWritingConfirmed = ref(false)



const level = route.params.level
const testId = route.params.testId

// Test metadata loaded from the backend (durations default to standard IELTS
// timings until the exam data arrives).
const listeningDuration = ref(30)
const readingDuration = ref(60)
const writingDuration = ref(60)
const loadError = ref("")

onMounted(async () => {
  try {
    const resolved = await resolveTest(level, testId)
    const [listening, reading, writing] = await Promise.allSettled([
      getListeningExam(resolved.id),
      getReadingExam(resolved.id),
      getWritingExam(resolved.id),
    ])
    if (listening.status === "fulfilled" && listening.value?.duration_minutes) {
      listeningDuration.value = listening.value.duration_minutes
    }
    if (reading.status === "fulfilled" && reading.value?.duration_minutes) {
      readingDuration.value = reading.value.duration_minutes
    }
    if (writing.status === "fulfilled" && writing.value?.duration_minutes) {
      writingDuration.value = writing.value.duration_minutes
    }
  } catch (e) {
    loadError.value = handleError(e, "MockExamPageDtail.load")
  }
})

const showListeningInfo = ref(false)
const isConfirmed = ref(false)
const startListening = () => {
 showListeningInfo.value = false
  router.push(`/listening-exam/${level}/${testId}`)

}
const startReading = () => {
  showReadingInfo.value = false
  router.push(`/reading-exam/${level}/${testId}`)
}


const startWriting = () => {
  showWritingInfo.value = false
  router.push(`/writing-exam/${level}/${testId}`)
}

function goBack() {
  const hasHistory = window.history.state && window.history.state.back
  if (hasHistory) {
    router.back()
  } else {
    router.push("/mock-exams")
  }
}
</script>
<style scoped>
.mock-exam-detail {
  --color-primary: #6D5EF8;
  --color-bg: #FCF9F6;
  --color-card: #FFFFFF;
  --color-border: #ECE4D9;
  --color-text: #4C372A;

  min-height: 100vh;
  background: var(--color-bg);
  padding: 56px 0 80px;
  direction: ltr;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.mock-exam-detail__inner {
  max-width: 960px;
}

.mock-exam-detail__back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--color-card);
  border: 1px solid var(--color-border);
  color: var(--color-text);
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  padding: 9px 18px;
  border-radius: 999px;
  cursor: pointer;
  margin-bottom: 28px;
  box-shadow: 0 2px 8px rgba(76, 55, 42, 0.06);
  transition: background-color 0.2s ease, transform 0.2s ease, border-color 0.2s ease;
}

.mock-exam-detail__back svg {
  flex-shrink: 0;
}

.mock-exam-detail__back:hover {
  background: #f5f3ff;
  border-color: var(--color-primary);
  transform: translateX(-2px);
}

.mock-exam-detail__back:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(109, 94, 248, 0.25);
}

.card {
  border-radius: 8px;
  border: 1px solid #ddd;
}

h1 {
  font-weight: 500;
  color: #1E40AF; 
  letter-spacing: 0.5px;
}

h3 {
  color: #2c3e50;
}
.status-text {
  color: #1E40AF;
  background-color: rgba(30, 64, 175, 0.08);
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 14px;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.35s ease;
  overflow: hidden;
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  max-height: 0;
  transform: translateY(-10px);
}

.slide-enter-to,
.slide-leave-from {
  opacity: 1;
  max-height: 500px;
  transform: translateY(0);
}
.bi {
  transition: transform 0.3s ease;
}
.confirm-btn {
  background-color: #1E40AF; /* همان آبی سایر المان‌ها */
  color: white;
  border: none;
  transition: background-color 0.3s ease;
}

.confirm-btn:hover {
  background-color: #3749c3; /* یک حالت هاور کمی روشن‌تر */
  color: white;

}
.test-info-text {
  transition: color 0.3s ease; /* تغییر رنگ آرام */
}

.test-info-text:hover {
  color: #1E40AF; /* رنگ آبی که با بقیه هماهنگ است */
  cursor: pointer; /* وقتی موس روی متن است، شکل موس تغییر کند */
}
.arrow-icon {
  margin-right: 6px;/* فاصله بین متن و فلش */
  transition: transform 0.3s ease;
}

.confirm-btn:hover .arrow-icon {
  transform: translateX(3px); /* حرکت فلش هنگام هاور */
}
</style>